import { XMark } from '@box/blueprint-web-assets/icons/Fill';
import { IconButton, Tooltip as BlueprintTooltip } from '@box/blueprint-web';
import PlainButton from 'box-ui-elements/es/components/plain-button';
import IconRemove from 'box-ui-elements/es/icons/general/IconRemove';
import BuieTooltip from 'box-ui-elements/es/components/tooltip';
import React from 'react';
// @ts-expect-error [MIGRATION-SUPPRESSION]: TS1484
import { injectIntl, IntlShape } from 'react-intl';
import { useShouldRenderBlueprint } from '../../../useShouldRenderBlueprint';
import VariantComponent from '../../../variant-component';
import messages from '../messages';
import css from './remove-button.module.scss';

type RemoveButtonProps = {
  intl: IntlShape;
  onClick: () => void;
};

const OldRemoveButton = ({ intl, ...props }: RemoveButtonProps) => {
  return (
    <BuieTooltip
      position="top-center"
      text={intl.formatMessage(messages.removeTooltip)}
    >
      <PlainButton {...props} data-testid="buie-remove-btn" type="button">
        <IconRemove />
      </PlainButton>
    </BuieTooltip>
  );
};

const NewRemoveButton = ({ intl, ...props }: RemoveButtonProps) => {
  return (
    <BlueprintTooltip
      content={intl.formatMessage(messages.removeTooltip)}
      side="top"
    >
      {/*
       // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2322 */}
      <IconButton
        {...props}
        className={css.removeButton}
        data-testid="blueprint-remove-btn"
        icon={XMark}
        size="x-small"
      />
    </BlueprintTooltip>
  );
};

const RemoveButton = (props: RemoveButtonProps) => {
  // Should be addressed in FORMS-21209
  const shouldRenderBlueprint = useShouldRenderBlueprint();
  return (
    <VariantComponent
      {...props}
      NewComponent={NewRemoveButton}
      OldComponent={OldRemoveButton}
      shouldRenderNewComponent={shouldRenderBlueprint}
    />
  );
};

export default injectIntl(RemoveButton);
